import { NgModule } from '@angular/core';
import { ReportBuilderStarterDirective } from './report-builder-starter.directive';
import { ReportBuilderStarterComponent } from './report-builder-starter.component';
import { ReportComplexManagerComponent } from "ng/src/app/reports/complex-manager/report-complex-manager.component";
import { SharedModule as LbSharedModule } from '../shared/shared.module';
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { SharedModule } from "primeng/api";
import { TableModule } from "primeng/table";
import { TagModule } from "primeng/tag";
import { ButtonModule } from "primeng/button";
import { DividerModule } from "primeng/divider";
import { InputTextareaModule } from "primeng/inputtextarea";
import { ConfirmPopupModule } from "primeng/confirmpopup";
import { AlertTriggerBuilderUpgradeComponent } from "ng/src/app/reports/upgrade/alert-trigger-builder-upgrade.component";

@NgModule({
	declarations: [
		ReportBuilderStarterDirective,
		ReportBuilderStarterComponent,
		ReportComplexManagerComponent,
		AlertTriggerBuilderUpgradeComponent
	],
	exports: [
		ReportComplexManagerComponent,
		AlertTriggerBuilderUpgradeComponent
	],
	imports: [
		LbSharedModule,
		CommonModule,
		FormsModule,
		SharedModule,
		TableModule,
		TagModule,
		ButtonModule,
		DividerModule,
		InputTextareaModule,
		ConfirmPopupModule
	]
})
export class ReportModule { }